export default __webpack_public_path__ + "static/media/2015327_univ_cnt_2_xl.2bcdf1b3.jpg";